<template>
  <main loadingactive="[object Object]">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/profile" aria-current="page"
            class="router-link-exact-active router-link-active" id="'breadcrumb0"><span to="">Account</span></a></li>
        <li class="breadcrumb-item"><span to="">Profile</span></li>
      </ol>
    </nav>
    <div>
      <h1>Profile</h1>
      <div class="section-group">
        <div class="mb-1">
          <div class="form row">
            <div class="form-group col-5">
              <h4 class="bold">Basic Info</h4>
              <div class="form-group row"><label for="username" class="col-4 col-form-label"
                  style="font-weight: bold;">Username</label>
                <div class="col-8"><input type="text" id="username" :value="getUser.username" name="username"
                    disabled="disabled" class="form-control"></div>
              </div>
              <div class="form-group row"><label for="name" class="col-4 col-form-label"
                  style="font-weight: bold;">Name</label>
                <div class="col-8"><input type="text" id="name" name="name" disabled="disabled" class="form-control">
                </div>
              </div>
              <div class="form-group row"><label for="phone" class="col-4 col-form-label"
                  style="font-weight: bold;">Phone</label>
                <div class="col-8"><input type="text" id="phone" name="phone" disabled="disabled" class="form-control">
                </div>
              </div>
              <div class="form-group row"><label for="PositionType" class="col-4 col-form-label"
                  style="font-weight: bold;">Position Type</label>
                <div class="col-8"><input type="text" id="PositionType" :value="getUser.roles[0]" name="PositionType"
                    disabled="disabled" class="form-control"></div>
              </div>
            </div>
            <div class="col-1"></div>
            <div class="col-5">
              <h4 class="bold">Credit</h4>
              <div class="form-group row"><label for="level" class="col-4 col-form-label"
                  style="font-weight: bold;">Level</label>
                <div class="col-8"><input type="text" id="level" name="level" :value="getUser.level" disabled="disabled"
                    class="form-control">
                </div>
              </div>
              <div class="form-group row"><label for="currency" class="col-4 col-form-label"
                  style="font-weight: bold;">Currency</label>
                <div class="col-8"><input type="text" id="currency" value="THB" name="currency" disabled="disabled"
                    class="form-control"></div>
              </div>
              <div class="form-group row"><label for="betType" class="col-4 col-form-label" style="font-weight: bold;">Bet
                  Type</label>
                <div class="col-8"><input type="text" id="betType" :value="getUser.wallet.type || '-'" name="betType"
                    disabled="disabled" class="form-control"></div>
              </div>
              <div class="form-group row"><label for="credit" class="col-4 col-form-label"
                  style="font-weight: bold;">Credit</label>
                <div class="col-8"><input type="text" id="credit" name="credit"
                    :value="getUser.wallet.credit | formatNumber" disabled="disabled" class="form-control"></div>
              </div>
            </div>
          </div>
          <div class="form row">
            <div class="form-group col-7">
              <h4>Agent Management</h4>
              <div data-v-535489f8="">
                <div data-v-535489f8="" class="form-group row"><label data-v-535489f8="" for="api-endpoint"
                    class="col-3 col-form-label" style="font-weight: bold;">API Endpoint</label>
                  <div data-v-535489f8="" class="col-6">
                    <div data-v-535489f8="" class="input-group mb-2"><input v-model="apiEndpoint" data-v-535489f8=""
                        type="text" id="api-endpoint" name="api-endpoint" readonly="readonly" class="form-control">
                      <div v-clipboard:copy="apiEndpoint" data-v-535489f8="" class="input-group-prepend copy"><button data-v-535489f8=""
                          class="input-group-text"><i data-v-535489f8="" class="far fa-copy"></i></button></div>
                    </div>
                  </div>
                </div>
                <div v-if="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="" class="form-group row"><label
                    data-v-535489f8="" for="secretKey" class="col-3 col-form-label" style="font-weight: bold;">Secret
                    Key</label>
                  <div data-v-535489f8="" class="col-6"><input v-model="SecertKey" value="" data-v-535489f8="" type="text"
                      id="secretKey" name="secretKey" readonly="readonly" class="form-control"></div>
                </div>
                <div v-if="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="" class="form-group row">
                  <div data-v-535489f8="" class="col-3"></div>
                  <div data-v-535489f8="" class="col-6" style="text-align: center; margin-top: 5px;"><button
                      @click="generateKey()" data-v-535489f8="" id="generate-key" data-toggle="modal"
                      data-target="#modalCenter" class="btn btn-yellow ripple-parent"><i class="fa fa-plus"
                        aria-hidden="true"></i> Generate API
                      Key </button></div>
                </div>
                <h4 v-if="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="">Whitelist IP (IPv4)</h4>
                <div v-if="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="" class="mb-4">
                  <div data-v-535489f8="" class="form-group row"><label data-v-535489f8="" for="addCallbackUrl"
                      class="col-3 col-form-label bold">WhiteList IP</label>
                    <div data-v-535489f8="" class="col-6"><input data-v-535489f8="" v-model="inputwhiteListApi"
                        type="text" id="addCallbackUrl" name="addCallbackUrl" placeholder="WhiteList IP"
                        required="required" class="form-control"></div>
                    <div data-v-535489f8="" class="col-1">
                      <div @click="addwhiteListApi()" data-v-535489f8=""><button data-v-535489f8="" type="button"
                          id="add-callbackUrl" class="btn btn-yellow ripple-parent btn-plus1 mr-2"><i class="fa fa-plus"
                            style="color:white;" aria-hidden="true"></i></button></div>
                    </div>
                  </div>
                </div>
                <div v-if="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="" class="mb-4">
                  <div data-v-535489f8="" class="row">
                    <div data-v-535489f8="" class="table-responsive col-10">
                      <table data-v-535489f8="" class="table table-bordered">
                        <thead data-v-535489f8="">
                          <tr data-v-535489f8="">
                            <th data-v-535489f8="">IP</th>
                            <th data-v-535489f8="">Action</th>
                          </tr>
                        </thead>
                        <tbody data-v-535489f8="">
                          <tr v-for="(item, index) in whiteListApi" v-bind:key="index" data-v-535489f8="">
                            <td data-v-535489f8="">{{ item }}</td>
                            <td data-v-535489f8=""><a @click="removewhiteListApi(index)" data-v-535489f8="" type="button"
                                id="delete-whitelist" class="btn btn-danger mr-2"><em data-v-535489f8=""
                                  class="fas fa-trash"></em></a></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <h4 v-show="getUser.wallet.type === 'seamless' && getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="">
                  Callback URL (Seamless)</h4>
                <form v-show="getUser.wallet.type === 'seamless' && getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8=""
                  class="forms-sample">
                  <div data-v-535489f8="" class="mb-4">
                    <div data-v-535489f8="" class="row">
                      <div data-v-535489f8="" class="col">
                        <nav data-v-535489f8="">
                          <div data-v-535489f8="" id="nav-tab" role="tablist" class="nav nav-tabs"><a data-v-535489f8=""
                              id="nav-EGAMES-tab" data-toggle="tab" href="#nav-EGAMES" role="tab"
                              aria-controls="nav-EGAMES" aria-selected="true"
                              class="nav-item nav-link nav-pill active"><span data-v-535489f8="">Games Slot</span></a><a
                              data-v-535489f8="" id="nav-LIVECASINO-tab" data-toggle="tab" href="#nav-LIVECASINO"
                              role="tab" aria-controls="nav-LIVECASINO" aria-selected="true"
                              class="nav-item nav-link nav-pill"><span data-v-535489f8="">Live
                                Casino</span></a><a data-v-535489f8="" id="nav-CARD-tab" data-toggle="tab"
                              href="#nav-CARD" role="tab" aria-controls="nav-CARD" aria-selected="true"
                              class="nav-item nav-link nav-pill"><span data-v-535489f8="">Game Card</span></a><a
                              data-v-535489f8="" id="nav-TRADING-tab" data-toggle="tab" href="#nav-TRADING" role="tab"
                              aria-controls="nav-TRADING" aria-selected="true" class="nav-item nav-link nav-pill"><span
                                data-v-535489f8="">Trading</span></a><a data-v-535489f8="" id="nav-POKER-tab"
                              data-toggle="tab" href="#nav-POKER" role="tab" aria-controls="nav-POKER"
                              aria-selected="true" class="nav-item nav-link nav-pill"><span
                                data-v-535489f8="">Poker</span></a></div>
                        </nav>
                        <div data-v-535489f8="" id="nav-tabContent" class="tab-content">
                          <div data-v-535489f8="" id="nav-LIVECASINO" role="tabpanel" aria-labelledby="nav-LIVECASINO-tab"
                            class="tab-pane fade">
                          </div>
                          <div data-v-535489f8="" id="nav-CARD" role="tabpanel" aria-labelledby="nav-CARD-tab"
                            class="tab-pane fade">
                          </div>
                          <div data-v-535489f8="" id="nav-EGAMES" role="tabpanel" aria-labelledby="nav-EGAMES-tab"
                            class="tab-pane fade active show">
                            <div data-v-535489f8="" class="report-by-currency">
                              <div data-v-535489f8="" class="mt-3">
                                <table data-v-535489f8="" class="table table-bordered table-hover">
                                  <thead data-v-535489f8="">
                                    <tr data-v-535489f8="">
                                      <th data-v-535489f8="" style="width: 2%;">No.</th>
                                      <th data-v-535489f8="" style="width: 34%;">Product Name</th>
                                      <th data-v-535489f8="" style="width: 64%;">Callback Url<br data-v-535489f8=""><small
                                          data-v-535489f8="" style="color: rgb(255, 255, 255) !important;">Ex:
                                          http://{YourCallbackUrl}</small></th>
                                    </tr>
                                  </thead>
                                  <tbody data-v-535489f8="">
                                    <tr v-for="(item, i) in products" v-bind:key="i"
                                      data-v-535489f8="">
                                      <td data-v-535489f8="" class="">1</td>
                                      <td data-v-535489f8="" class="" style="text-align: left;"><label
                                          data-v-535489f8="">{{ item.productId }}</label></td>
                                      <td data-v-535489f8="" class=""><input data-v-535489f8="" type="text"
                                          v-model="products[i].callbackUrl" class="form-control">
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div data-v-535489f8="" id="nav-TRADING" role="tabpanel" aria-labelledby="nav-TRADING-tab"
                            class="tab-pane fade">
                          </div>
                          <div data-v-535489f8="" id="nav-POKER" role="tabpanel" aria-labelledby="nav-POKER-tab"
                            class="tab-pane fade">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
                <div @click="savewhiteListApi()" data-v-535489f8="" style="text-align: center;"><button data-v-535489f8=""
                    type="button" id="add-whitelist" class="btn btn-yellow ripple-parent">Save</button></div>
                <!---->
                <div v-show="getUser.roles[0] != 'SUBACCOUNT'" data-v-535489f8="" id="modalDeleteWhiteList" tabindex="-1"
                  role="dialog" aria-labelledby="modalDeleteWhiteListTitle" aria-hidden="true" class="modal fade">
                  <div data-v-535489f8="" role="document" class="modal-dialog modal-dialog-centered">
                    <div data-v-535489f8="" class="modal-content">
                      <div data-v-535489f8="" class="modal-header">
                        <h5 data-v-535489f8="" id="exampleModalDeleteWhiteListTitle" class="modal-title">Delete
                          Whitelist</h5><button data-v-535489f8="" type="button" data-dismiss="modal" aria-label="Close"
                          class="close"><span data-v-535489f8="" aria-hidden="true">×</span></button>
                      </div>
                      <div data-v-535489f8="" class="modal-body">
                        <p data-v-535489f8="">คุณต้องการลบ Whitelist ip : </p>
                      </div>
                      <div data-v-535489f8="" class="modal-footer"><button data-v-535489f8=""
                          class="btn btn-danger">Confirm</button><button data-v-535489f8="" type="button" id="modal-close"
                          data-dismiss="modal" class="btn btn-secondary">Close</button></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import api from '../services/index.js'
import Swal from "sweetalert2";
import { mapGetters } from 'vuex'

export default {
  name: "Profile",
  data() {
    return {
      apiEndpoint: "https://api-main.newgameslot.com/",
      SecertKey: "Contact an administrator",
      inputwhiteListApi: "",
      whiteListApi: ["ANY"],
      products: []
    };
  },
  async mounted() {
    await this.getwhiteListApi();
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    async ValidateIPaddress(ipaddress) {
      if(!this.checkBadIPaddress(ipaddress)){
        return Swal.fire("You have entered an invalid IP address!", "", "warning");
      }
      if (/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(ipaddress)) {
        return true;
      }
      Swal.fire("You have entered an invalid IP address!", "", "error");
      return false;
    },
    async checkBadIPaddress(ipaddress) {
      if(ipaddress === '127.0.0.1' || ipaddress === 'localhost') return false;
      return true;
    },
    async addwhiteListApi() {
      if (!await this.ValidateIPaddress(this.inputwhiteListApi)) return false;
      if (this.whiteListApi.length >= 3 || this.inputwhiteListApi == "") return false;
      if (this.whiteListApi.find(x => x === this.inputwhiteListApi)) return false;
      this.whiteListApi.push(this.inputwhiteListApi);
    },
    async removewhiteListApi(index) {
      if (this.whiteListApi > 3) return false;
      this.whiteListApi.splice(index, 1);
    },
    async getwhiteListApi() {
      await api.get(`/whilelistIp`).then((obj) => {
        if (obj.success == true) {
          this.whiteListApi = (obj.data.whiteListIp) ? obj.data.whiteListIp : [];
          this.products = (obj.data.Royalty) ? obj.data.Royalty : [];
        } else {
          Swal.fire("แจ้งเตือน", obj.error.message, "error");
        }
      })
        .catch((e) => {
          Swal.fire("แจ้งเตือน", e.response.data.error.message, "error");
        });
    },
    async savewhiteListApi() {
      await api.post(`/whilelistIp`,{ whiteListIp: this.whiteListApi, Royalty: this.products }).then((obj) => {
        if (obj.success == true) {
          Swal.fire("Password changed Successfully.", "", "success");
        } else {
          Swal.fire("แจ้งเตือน", obj.error.message, "error");
        }
      })
        .catch((e) => {
          Swal.fire("แจ้งเตือน", e.response.data.error.message, "error");
        });
    },
    async generateKey() {
      await api.post(`/generateKey`).then((obj) => {
        if (obj.success == true) {
          Swal.fire(`${obj.data.secert_key}`, "", "success");
        } else {
          Swal.fire("แจ้งเตือน", obj.error.message, "error");
        }
      })
        .catch((e) => {
          Swal.fire("แจ้งเตือน", e.response.data.error.message, "error");
        });
    },
    async ChangePassword() {
      if (this.old_password == "" || this.password == "" || this.confirm_password == "") {
        Swal.fire("แจ้งเตือน", "ข้อมูลไม่ควรมีช่องว่าง", "warning");
        return;
      }
      await api.put('/change-password', {
        old_password: this.old_password,
        password: this.password,
        confirm_password: this.confirm_password
      })
        .then((obj) => {
          if (obj.success == true) {
            Swal.fire("Password changed Successfully.", "", "success");
          } else {
            Swal.fire("แจ้งเตือน", obj.error.message, "error");
          }
        })
        .catch((e) => {
          Swal.fire("แจ้งเตือน", e.response.data.error.message, "error");
        });
    }
  },
};
</script>